import { SET_HUB_READY } from './hub-mutation-types';
import {
	ON_CONNECT_METHOD,
	ON_DISCONNECT_METHOD,
	SEND_COMMUNICATION_METHOD,
	ON_CONNECTION_CLOSE
} from './hub-methods';
import { NEW_COMMUNICATION_TARGET } from './hub-targets';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import consoleLog from '@/utils/console-log';
import store from '@/store/index.js';

let hubConnection;
let parentAppStore;

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'hub',
	namespaced: true,
	state: {
		hubReady: false,
		hubLogLevel: process.env.VUE_APP_LOG_LEVEL,
		newCommunicationTarget: NEW_COMMUNICATION_TARGET
	},
	mutations: {
		[SET_HUB_READY](state, ready) {
			state.hubReady = ready;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		receiveCommunicationAction({ commit, dispatch }, message) {
			consoleLog('receiveCommunicationAction');
			consoleLog(message);

			//where message.action would be the store action
			if (message.Actions && Array.isArray(message.Actions)) {
				message.Actions.forEach(action => {
					if (action.includes('/')) {
						//if the action contains a /, then we're invoking
						//a mutation in a different module
						parentAppStore.dispatch(action, message.Data);
					} else {
						//action is in this module
						dispatch(action, message.Data);
					}
				});
			}

			//where message.mutation would be the mutation type, ie SET_CONCURRENT_USERS
			if (message.Mutations && Array.isArray(message.Mutations)) {
				message.Mutations.forEach(mutation => {
					if (mutation.includes('/')) {
						//if the action contains a /, then we're invoking
						//a mutation in a different module
						parentAppStore.commit(mutation, message.Data);
					} else {
						//mutation is in this module
						commit(mutation, message.Data);
					}
				});
			}

			store.dispatch('logging/logEventAction', {
				data: {
					event: 'Receive Communication Action',
					target: 'HubModule',
					eventData: message
				}
			});
		},
		// eslint-disable-next-line no-unused-vars
		invokeHubMethodAction({ commit }, { message, method }) {
			consoleLog('invokeHubMethodAction');
			const user = store.getters['user/userInfo'];

			if (user) {
				if (!message.dealershipGroupId) {
					message.dealershipGroupId = user.AspNetCompaniesId;
				}

				if (!message.companyId) {
					message.companyId = user.CurrentEmployeeCompanyId;
				}
			}

			hubConnection.invoke(
				method || SEND_COMMUNICATION_METHOD,
				JSON.stringify(message)
			);
		},
		setHubConnectionAction(
			{ commit, dispatch, state },
			{ userToken, user }
		) {
			const connection = new HubConnectionBuilder()
				.withUrl(store.getters['user/VUE_APP_SIGNALR_CONNECTION'], {
					accessTokenFactory: () => {
						return userToken;
					}
				})
				.configureLogging(LogLevel[state.hubLogLevel])
				.build();

			connection.on(state.newCommunicationTarget, message => {
				dispatch('receiveCommunicationAction', message);
			});

			//TODO: this fires when a connection is closed,
			//not when the user leaves the page or closes the browser
			//figure out how to test
			connection.onclose(() => {
				dispatch('invokeHubMethodAction', {
					message: {
						data: user,
						dealershipGroupId: user.AspNetCompaniesId,
						companyId: user.CurrentEmployeeCompanyId
					},
					method: ON_CONNECTION_CLOSE
				});

				consoleLog('disconnected');
			});

			connection
				.start()
				.then(() => {
					commit(SET_HUB_READY, true);

					consoleLog('hub connection ready');

					dispatch('onUserConnectedAction', user);
				})
				.catch(e => {
					consoleLog(e);
				});

			hubConnection = connection;
		},
		onUserConnectedAction({ dispatch }, user) {
			consoleLog('onUserConnectedAction');

			dispatch('invokeHubMethodAction', {
				message: {
					data: user,
					dealershipGroupId: user.AspNetCompaniesId,
					companyId: user.CurrentEmployeeCompanyId
				},
				method: ON_CONNECT_METHOD
			});
		},
		onUserDisconnectAction({ dispatch }, user) {
			consoleLog('onUserDisconnectAction');

			dispatch('invokeHubMethodAction', {
				message: {
					data: user,
					dealershipGroupId: user.AspNetCompaniesId,
					companyId: user.CurrentEmployeeCompanyId
				},
				method: ON_DISCONNECT_METHOD
			});
		},
		// eslint-disable-next-line no-unused-vars
		setParentAppStoreAction({ commit }, store) {
			//commiting this into a state prop was causing an error,
			//so just putting in a local var
			parentAppStore = store;
		},
		// eslint-disable-next-line no-unused-vars
		addMessageHandlerAction({ commit }, { target, handler }) {
			hubConnection.on(target, handler);
		}
	},
	getters: {
		hubReady: state => state.hubReady
	}
};
